import { z } from 'zod'

// Контракт ручек /api/reports/* описан здесь, пока обновлённый openapi.json
// бэкенда не приехал: после `pnpm gen` эти схемы заменяются генерённым apiZod.
const TotalsDto = z.object({
  meeting_count: z.number(),
  seconds: z.number(),
  private_meeting_count: z.number().default(0),
})

export const ProjectRowDto = TotalsDto.extend({
  project_id: z.string().optional(),
  project_name: z.string().optional(),
  company_id: z.string().optional(),
  company_name: z.string().optional(),
})
export type ProjectRowDto = z.infer<typeof ProjectRowDto>

export const CompanyRowDto = TotalsDto.extend({
  company_id: z.string().optional(),
  company_name: z.string().optional(),
})
export type CompanyRowDto = z.infer<typeof CompanyRowDto>

export const EmployeeRowDto = TotalsDto.extend({
  subject: z.string(),
  username: z.string(),
  full_name: z.string(),
  projects: z.array(ProjectRowDto).default([]),
  companies: z.array(CompanyRowDto).default([]),
})
export type EmployeeRowDto = z.infer<typeof EmployeeRowDto>

function responseOf<Row extends z.ZodType>(row: Row) {
  return z.object({ data: z.array(row).default([]) })
}

export const EmployeeReportResponseDto = responseOf(EmployeeRowDto)
export const ProjectReportResponseDto = responseOf(ProjectRowDto)
export const CompanyReportResponseDto = responseOf(CompanyRowDto)
